import { render, staticRenderFns } from "./paperDetail.vue?vue&type=template&id=188b8be4&scoped=true"
import script from "./paperDetail.vue?vue&type=script&lang=ts"
export * from "./paperDetail.vue?vue&type=script&lang=ts"
import style0 from "./paperDetail.vue?vue&type=style&index=0&id=188b8be4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188b8be4",
  null
  
)

export default component.exports